module.exports = __webpack_public_path__ + "static/media/08.acae58fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/08.png
// module id = 179
// module chunks = 0